module.exports = __webpack_public_path__ + "files/siAli.86fcecd148efd47c9266a49e0967bfd0.pdf";